import { Col, Collapse, Container, Row } from "react-bootstrap";
import { SetURLSearchParams } from "react-router-dom";
import { SystemSearchParams } from "../SystemParameters";
import { useSetSearchUrlParams } from "../../../../../hooks/usePagination";
import styles from "./SystemParametersSearchContainer.module.css"
import { JSX, useEffect, useState } from "react";
import DefaultButton from "../../../../../components/buttons/default-button/DefaultButton";
import FilterButton from "../../../../../components/buttons/filter-button/FilterButton";

interface SearchContainerProps {
    searchParameters: SystemSearchParams
    setSearchParams: SetURLSearchParams
    pagination: JSX.Element
}

export default function SearchContainer(props: SearchContainerProps) {
    const { searchParameters, setSearchParams, pagination } = props
    const [ showSearchContainer, setShowSearchContainer ] = useState(false)
    const setSearchUrlParams = useSetSearchUrlParams(setSearchParams)
    const [id, setId] = useState(searchParameters.id ?? '')
    const [parameterName, setParameterName] = useState(searchParameters.name ?? '')
    const [parameterValue, setparameterValue] = useState(searchParameters.value ?? '')

    useEffect(() => {
        setId(searchParameters.id ?? '')
        setParameterName(searchParameters.name ?? '')
        setparameterValue(searchParameters.value ?? '')
    }, [ searchParameters ])

    return(
        <Container className={styles.searchContainer}>
            <Row className="g-0 position-relative">
                <Col className="col-4 d-flex align-items-center">
                    <div>
                        <FilterButton title="Szűrő" onClick={() => setShowSearchContainer(prev => !prev)} isOpen={showSearchContainer} />
                    </div>
                </Col>

                <div className="col-8 d-flex relative align-items-center flex-row-reverse">
                   { pagination }
                </div>
            </Row>

            <Collapse in={ showSearchContainer }>
                <div>
                    <Row className={styles.inputFieldsContainer}>
                        <Row className="g-0">
                            <Col className={`d-flex justify-content-center gap-4 align-items-center`}>
                                <div>
                                    <label className={styles.label} htmlFor="id">ID</label>
                                    <input
                                        type="number"
                                        id='id'
                                        placeholder='ID'
                                        value={id}
                                        className={styles.searchInput}
                                        onChange={e => {
                                            const value = e.target.value
                                            setId(value)
                                            
                                            const id = parseInt(value)

                                            if(value.toString().length === 0 || isNaN(id)) {
                                                searchParameters.id = null
                                                return
                                            }

                                            searchParameters.id = id
                                        }}
                                    />
                                </div>

                                <div>
                                    <label className={styles.label} htmlFor="parameterName">Név</label>
                                    <input
                                        type="text"
                                        id='parameterName'
                                        placeholder='Név'
                                        value={ parameterName }
                                        className={styles.searchInput}
                                        onChange={e => {
                                            const parameterName = e.target.value
                                            setParameterName(parameterName)

                                            if(parameterName.length === 0) {
                                                searchParameters.name = null
                                                return
                                            }

                                            searchParameters.name = parameterName
                                        }}
                                    />
                                </div>

                                <div>
                                    <label className={styles.label} htmlFor="parameterValue">Érték</label>
                                    <input
                                        type="text"
                                        id='parameterValue'
                                        placeholder='Érték'
                                        value={ parameterValue }
                                        className={styles.searchInput}
                                        onChange={e => {
                                            const parameterValue = e.target.value
                                            setparameterValue(parameterValue)

                                            if(parameterValue.length === 0) {
                                                searchParameters.value = null
                                                return
                                            }

                                            searchParameters.value = parameterValue
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="g-0">
                            <Col className={`d-flex justify-content-center align-items-end position-relative`}>
                                <DefaultButton title="Keresés" onClick={e => {
                                    e.preventDefault()
                                    setSearchUrlParams(searchParameters)
                                }} />
                            </Col>
                        </Row>
                    </Row>
                </div>
            </Collapse>
        </Container>
    )
}